var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.people_around),function(item){return _c('Person',{key:item.id,attrs:{"person":item}})}),_c('infinite-loading',{on:{"infinite":_vm.infiniteHandler}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }